import React from 'react'
import { Table } from 'reactstrap'
import CompanyTableItem from './CompanyTableItem'

const CompaniesTable = ({ companies, isAdmin, isSales, currentPage, pageSize }) => {
  return (
    <div>
      <Table>
        <thead>
          <tr>
            <th>Company Name</th>
            <th>Remaining Reconciliations</th>
            <th>Total Products</th>
            <th>Remaining Products</th>
            <th> </th>
          </tr>
        </thead>
        {companies == null || companies.length === 0 ? (
          <tr>
            <td colSpan="6" style={{ textAlign: 'center', fontSize: '1.25rem' }}>
              No Companies Found
            </td>
          </tr>
        ) : (
          <tbody>
            {companies.slice(currentPage * pageSize, currentPage * pageSize + pageSize).map((company, index) => (
              <CompanyTableItem isAdmin={isAdmin} isSales={isSales} key={index} company={company} />
            ))}
          </tbody>
        )}
      </Table>
    </div>
  )
}

export default CompaniesTable
